<template>
    <div class="app-wrapper" :class="{hideSidebar:!sidebar.opened}">
        <sidebar class="sidebar-container"></sidebar>
        <div class="main-container">
            <navbar></navbar>
            <tags-view></tags-view>
            <app-main></app-main>
        </div>
    </div>
</template>

<script>
    import navbar from './components/navbar'
    import sidebar from './components/sidebar'
    import appMain from './components/appMain'
    import TagsView from './components/TagsView'
    import {getToken} from '@/utils/auth'
    import itemVue from '../base/projPlanTpl/item.vue'

    export default {
        name: 'layout',
        components: {
            navbar,
            sidebar,
            appMain,
            TagsView
        },
        data() {
            return {
                notify: {},
                message: [],
                timer: null
            }
        },
        computed: {
            sidebar() {
                return this.$store.state.app.sidebar
            }
        },
        methods: {
            aa() {
                if (this.$store.getters.userInfo.neverLogin == 1) {
                    const userName = this.$store.getters.userInfo.userName
                    var count = 0
                    var msg = ''
                    this.$fetchData(this.$api.myjob.getCount, null, 'post').then(res => {
                        count = res.num
                        localStorage.setItem("workFlowCount", count + "")
                        if (res.num > 0) {
                            msg = `您好!&nbsp;&nbsp;&nbsp;<strong>${userName}<br>您有<span style="color: red;">${count}</span>条待办事项&nbsp;&nbsp;&nbsp;
            <a style="color: red;" href="/#/todoList"><u>查看</u><i class="el-icon-d-arrow-right"></i></a></strong>`
                        } else {
                            msg = `您好!&nbsp;&nbsp;&nbsp;<strong>${userName}<br><i>您没有待办事项</a></strong>`
                        }
                        this.$notify.info({
                            title: '待办通知',
                            dangerouslyUseHTMLString: true,
                            position: 'bottom-right',
                            duration: 20000,
                            iconClass: 'el-icon-bell',
                            message: msg
                        });
                        this.messageRemind()
                    })
                }

            },
            bb() {

                if (this.$store.getters.userInfo.neverLogin == 1) {
                    const userName = this.$store.getters.userInfo.userName
                    var count = 0
                    var msg = ''

                    this.$fetchData(this.$api.BusiMessage.getCount).then(res => {
                        count = res
                        var item = localStorage.getItem("workFlowCount");
                        if (res > Number(item)) {
                            localStorage.setItem("workFlowCount", count + "")
                            this.$fetchData(this.$api.BusiMessage.getMessage, null, 'get').then(res => {
                                msg = `您有新的消息:<br>
            ${res.title}<br>
            ${res.content}<br> `
                                // <a href="/#/todoList"><i class="el-icon-caret-bottom"><u>查看</u></i></a>`
                                this.$notify.info({
                                    title: '消息通知',
                                    dangerouslyUseHTMLString: true,
                                    position: 'bottom-right',
                                    duration: 20000,
                                    iconClass: 'el-icon-bell',
                                    message: msg
                                });
                                this.messageRemind()
                            })
                        } else {
                            localStorage.setItem("workFlowCount", count + "")
                        }

                    })
                }
            },
            async creatNotify() {
                const h = this.$createElement;
                let len = this.message.length
                for (let i = 0; i < len; i++) {
                    let item = this.message[i]
                    let notify = await this.$notify({
                        title: item.title,
                        message: h(
                            "p",
                            {
                                style: "width: 250px;",
                            },
                            [
                                h("span", null, item.content),
                                h(
                                    "a",
                                    {
                                        style: "cursor: pointer;color: #fff;padding: 0 5px;background: rgb(64, 158, 255);border-radius: 4px;font-size: 12px;float: right;",
                                        on: {
                                            click: () => {
                                                this.setRead(item)
                                            },
                                        },
                                    },
                                    "已读"
                                ),

                            ]
                        ),
                        position: "top-right",
                        type: 'info',
                        duration: 0,
                    });
                    this.notify[item.id] = notify
                }
                ;

            },
            cc() {
                this.$fetchData(this.$api.BusiMessage.getMessage + '/3', null, 'get').then(res => {
                    for (let key in this.notify) {
                        this.notify[key].close();
                    } //关闭全部通知
                    this.message = res
                    if (res.length) {
                        this.creatNotify()
                    }
                })
            },
            setRead(item) {
                console.log(item)
                if (item && item.id) {
                    this.$fetchData(this.$api.BusiMessage.backUpdateIsReadBusiMessage, [item.id], 'post').then(res => {
                        this.notify[item.id].close() //关闭当前通知
                        delete this.notify[item.id]
                    }).catch(error => {

                    })
                }

            },
            messageRemind() {
                this.ss = new Audio("/music/message.mp3")
                this.ss.play();
            }
        },
        created() {
            this.messageRemind();
            //非开发环境下才发请求
            this.aa()
            if (process.env.VUE_APP_NOTICE == 'true') {
                setInterval(() => {
                    this.bb()
                }, 50000)
            }
            if (this.$store.getters.userInfo.neverLogin == 1) {
                this.cc()
                this.timer = setInterval(() => {
                    this.cc()
                }, 3600000)
            }
        },
        beforeDestroy() {
            clearInterval(this.timer);
            this.timer = null;
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    @import "../../assets/styles/mixin.scss";

    .app-wrapper {
        @include clearfix;
        position: relative;
        height: 100%;
        width: 100%;
    }
</style>
